import React from 'react';
import SearchHighlight from './SearchHighlight';

const PolicySection = ({ section, searchTerm, isActive }) => {
  if (!section) return null;

  return (
    <section
      id={section?.id}
      className={`
        scroll-mt-24 transition-all duration-200
        ${isActive ? 'bg-blue-50 border-l-4 border-blue-500 pl-6' : ''}
      `}
    >
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">
          <SearchHighlight text={section?.title} searchTerm={searchTerm} />
        </h3>
        
        <div className="prose prose-gray max-w-none">
          <div className="text-gray-700 leading-relaxed whitespace-pre-line">
            <SearchHighlight text={section?.content} searchTerm={searchTerm} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PolicySection;